<template lang="pug">
  v-dialog(no-click-animation persistent v-model="dialog" max-width=440, hide-overlay)
    v-card(v-if="one !== null")
      v-card-title.app-append.white--text
        span {{$t('append')}}
        v-spacer
        v-btn(text small icon color="white" @click.stop="$emit('closeDialog')")
          v-icon close

      v-card-text
        v-autocomplete.mt-4(
          autofocus
          :items="genuses"
          :label="$t('genus_title')"
          item-text="name"
          item-value="id"
          v-model="one.genus"
          validate-on-blur
          ref="genus"
          :rules="[rules.required]"
          clearable
          em="1"
          :filter="customFilter"
        )

        v-text-field.mt-3(
          type="text"
          :label="$t('item.name')"
          v-model="one.name"
          autocapitalize="off"
          ref="name"
          :rules="[rules.required]"
          validate-on-blur
          em="2"
        )

        v-text-field.mt-3(
          type="text"
          :label="$t('item.short_name')"
          v-model="one.short_name"
          autocapitalize="off"
          ref="short_name"
          em="3"
        )

        v-text-field.mt-3(
          type="text"
          :label="$t('item.name_eng')"
          v-model="one.name_eng"
          autocapitalize="off"
          ref="name_eng"
          em="4"
        )

        v-text-field.mt-3(
          type="text"
          :label="$t('item.repack_name')"
          v-model="one.repack_name"
          autocapitalize="off"
          ref="repack_name"
          em="5"
        )

        v-autocomplete.mt-3(
          :items="units"
          :label="$t('item.unit')"
          item-text="name"
          item-value="id"
          v-model="one.unit"
          return-object
          ref="unit"
          :rules="[rules.required]"
          validate-on-blur
          em="6"
        )

        v-checkbox.margin-checkbox(
          v-model="one.is_one_label"
          :label="$t('item.is_one_label')"
          em="7"
        )

        v-combobox.mt-3(
          multiple
          hide-no-data
          :label="$t('tag')"
          chips
          solo
          prepend-inner-icon="fa-tags"
          clearable
          v-model="one.tags"
          hide-details
          em="8"
        )

          template(slot="selection" slot-scope="data")
            v-chip(
              close
              small
              color="blue-grey lighten-3"
              @click:close="removeTag(data.item)"
              :input-value="data.selected")
              span {{data.item}}
        span.remarks {{$t('tags_description')}}

      v-card-actions
        v-spacer
        v-btn(
          text
          color="app-append"
          @click.stop="save")
          span {{$t('save')}}
</template>

<script>
import rules from '@/common/mixins/rules'
import customFilter from '@/app/mixins/utils'

export default {
  data () {
    return {
      exclusiveLock: false,
      one: null
    }
  },
  props: {
    genuses: {
      type: Array
    },
    units: {
      type: Array,
      required: true
    },
    genus: Number,
    showDialog: {
      type: Boolean,
      default: false,
      required: false
    },
    dialog: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      default: '',
      required: false
    }
  },
  watch: {
    dialog (newVal, oldVal) {
      if (!newVal) {
        this.one = null
      } else if (!oldVal && newVal) {
        this.one = {
          name: this.search,
          short_name: this.short_name ? this.short_name : null,
          name_eng: '',
          repack_name: this.repack_name ? this.repack_name : null,
          genus: this.genus ? this.genus : null,
          is_one_label: false,
          unit: this.units.length > 0 ? this.units[0] : null, // default as 本
          tags: []
        }
        this.resetRuleError()
        this.dialog = true
        this.$emit('entermove-refresh-request')
      }
    }
  },
  mixins: [rules, customFilter],
  methods: {
    removeTag (tag) {
      this.one.tags.splice(this.one.tags.indexOf(tag), 1)
      this.one.tags = [...this.one.tags]
    },
    save () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true

      let objParam = { ...this.one }
      objParam.id = null
      objParam.unit = objParam.unit.id
      this.$ajax
        .post('/item/save', objParam)
        .then(response => {
          this.exclusiveLock = false
          this.$emit('complete', response.data)
        })
        .catch((messages, error) => {
          this.exclusiveLock = false
          messages.map(message => this.$toastr.error(message))
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.margin-checkbox {
  margin: -8px 0 -20px -4px
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Master/Item/append.vue